import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import {TableModule} from 'primeng/table';
import {ChartModule} from 'primeng/chart';

@NgModule({
  exports: [ChartModule,FormsModule, CommonModule,TableModule, NgbModule,  FontAwesomeModule, ReactiveFormsModule, TranslateModule],
})
export class SharedLibsModule {}
